import { Plane, Raycaster, Vector2, Vector3 } from 'three';

const raycaster = new Raycaster();
const mouseNdc = new Vector2();
const groundPlane = new Plane(new Vector3(0, 1, 0), 0);
const pointerWorld = new Vector3();
let targetElement = null;

export function initPointerAim(camera, element = window) {
  targetElement = element;
  window.addEventListener('pointermove', updatePointerPosition);

  return function getPointerWorld() {
    raycaster.setFromCamera(mouseNdc, camera);
    raycaster.ray.intersectPlane(groundPlane, pointerWorld);
    return pointerWorld;
  };
}

function updatePointerPosition(event) {
  const rect = targetElement?.getBoundingClientRect?.() || {
    left: 0,
    top: 0,
    width: window.innerWidth || 1,
    height: window.innerHeight || 1,
  };
  mouseNdc.set(
    ((event.clientX - rect.left) / Math.max(1, rect.width)) * 2 - 1,
    -((event.clientY - rect.top) / Math.max(1, rect.height)) * 2 + 1,
  );
}
